import React, { useContext, useEffect, useState } from "react";
import {
  Navigate,
  createSearchParams,
  useLocation,
  useParams,
  useSearchParams,
  matchPath,
  Outlet,
} from "react-router-dom";
import { AccountContext } from "./account";
import { APIProvider } from "../api";
import { RealtimeProvider } from "../realtime";
import { PaywallProvider } from "../paywall";
import { GrigoraAccount } from "../grigora-account";

function LoginRequired({ redirect, not = false, children }) {
  const { currentUser, sessionLoaded } = useContext(AccountContext);
  const location = useLocation();

  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get("return");

  return not ? (
    sessionLoaded ? (
      currentUser ? (
        <Navigate replace to={returnTo ? returnTo : redirect} />
      ) : (
        <>
          {/* <Outlet /> */}
          {children}
        </>
      )
    ) : (
      <></>
      // (activeScreen === "dashboard" ? <DashboardSkeleton key={"dashboard-skeleton"} /> : activeScreen === "editor" ? <EditorSkeleton key={"loading"} /> : activeScreen === "cms/addpost" || activeScreen === "cms/editpost" ? <PostEditSkeleton key={"loading"} /> : <></>)
    )
  ) : sessionLoaded ? (
    currentUser ? (
      <PaywallProvider>
        <APIProvider>
          <RealtimeProvider>
            <GrigoraAccount>{children}</GrigoraAccount>
          </RealtimeProvider>
        </APIProvider>
      </PaywallProvider>
    ) : (
      <Navigate
        replace
        to={{
          pathname: redirect,
          search: createSearchParams({
            return: location.pathname + location.search,
          }).toString(),
        }}
      />
    )
  ) : (
    <></>
    // (activeScreen === "dashboard" ? <DashboardSkeleton key={"dashboard-skeleton"} /> : activeScreen === "editor" ? <EditorSkeleton key={"editor-skeleton"} /> : activeScreen === "cms/addpost" || activeScreen === "cms/editpost" ? <PostEditSkeleton key={"posteditor-skeleton"} /> : <></>);
  );
}

export default LoginRequired;
